import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {isPlatformBrowser, PlatformLocation} from '@angular/common';
import {AppConfig} from './app.config';
import {getHost} from '../util/EnvironmentUtil';
import {Router} from '@angular/router';
import {Location} from '@angular/common';


@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  private _authConfig: AppConfig = null;

  constructor(@Inject(PLATFORM_ID) private platformId: Object,
              private httpClient: HttpClient,
              @Inject('env') private environment,
              private platformLocation: PlatformLocation,
              private router: Router, private location: Location) {
  }

  get config(): AppConfig {
    return this._authConfig;
  }

  getEnv(): string {
    if (isPlatformBrowser(this.platformId)) {
      return this.environment.config.env;
    }
  }

  getRestEndpoint(): string {
    if (isPlatformBrowser(this.platformId) && !this.environment.production) {
      // This is for local testing without the REST backend app config
      return 'assets/data/app-config.json';
    } else {
      const host: string = getHost(this.platformId, this.platformLocation);
      return `${host}/api/config`;
    }
  }

  /**
   * Load configuration needed by the application from server side
   * This method will be called during APP_INITIALIZER phase (see AppModule)
   */
  load(url: string) {
    const restEndPoint = this.getRestEndpoint();
    return this.httpClient.get<AppConfig>(restEndPoint)
    .toPromise()
    .then(response => {
        this._authConfig = response;
        this.environment.config = response;
        if(this.location.path().length > 2){
          url = this.location.path();
        }
        this.router.navigateByUrl(url);
      },
      error => {

      }
    ).finally(() =>{

    });
  }

  isStaffInterface(){
    return this.environment.config.interfaceType === "STAFF"
  }

  isTldManagerInterface(){
    return this.environment.config.interfaceType === 'TLD_MANAGER';
  }

  getTermsAndPrivacyVersion() {
    return this.environment.config.termsAndPrivacyAcknowledgmentVersion;
  }

  isLoggedIn(): boolean { //todo temp- use method from auth service
    if (isPlatformBrowser(this.platformId)) {
      return this.currentUserAuthVO() != null;
    }
    return false;
  }

  currentUserAuthVO() {
    const user = localStorage.getItem('user');
    if (user) {
      try {
        return JSON.parse(user);
      } catch (e) {
        return null;
      }
    } else {
      return null;
    }
  }
}
